import { db } from '@/main.js'
import moment from 'moment'

const INTERVAL = 30

export default {
  props: ['profile', 'site'],
  data() {
    return {
      interval: undefined,
      analytics: [],
      analytics_live: [],
      date_range: {startDate: new Date(), endDate: new Date()},
      fields: [
        {key: 'referrer'},
        {key: 'count', sortable: true, sortDirection: 'desc'},
      ]
    }
  },
  firestore: function () {
    return {
      analytics: db.collection('site').doc(this.$route.params.site_id).collection('analytics').where('event', '==', 'page_view').where('created', '>=', moment(this.date_range.startDate).startOf('day').toDate()).where('created', '<=', moment(this.date_range.endDate).endOf('day').toDate()),
    }
  },
  methods: {
    async check_live() {
      if (!this.$route.params.site_id) {
        return
      }
      let docs = await db.collection('site').doc(this.$route.params.site_id).collection('analytics').where('event', '==', 'live').where('created', '>=', moment().subtract(INTERVAL, 'seconds').toDate()).get()
      let analytics_live = []
      for (let doc of docs.docs) {
        analytics_live.push(doc.data())
      }

      this.analytics_live = analytics_live
    }
  },
  mounted() {
    this.check_live()
    if (!this.interval) {
      this.interval = setInterval(this.check_live, INTERVAL * 1000)
    }
  },
  unmounted() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = undefined
    }
  },
  computed: {
    live_stats() {
      let live = {}
      let live_total = 0
      for (let event of this.analytics_live) {
        if (!live[event.url]) {
          live[event.url] = {url: event.url, count: 0}
        }
        live[event.url].count++
        live_total++
      }

      return {
        live_total, live
      }
    },
    stats() {
      let users = {}
      let referrers = {}

      for (let event of this.analytics) {
        if (event.new) {
          users[event.uid] = 'new'
        } else if (!users[event.id]) {
          users[event.uid] = 'returning'
        }

        if (event.referrer) {
          if (!referrers[event.referrer]) {
            referrers[event.referrer] = {referrer: event.referrer, count: 0}
          }
          referrers[event.referrer].count++
        }
      }

      let new_users = 0
      let returning_users = 0
      for (let key in users) {
        let user = users[key]
        if (user === 'new') {
          new_users++
        }
        if (user === 'returning') {
          returning_users++
        }
      }

      referrers = Object.values(referrers)

      return {
        new_users, returning_users, referrers
      }
    }
  }
}
